import { lighten, getColor, mode } from '@chakra-ui/theme-tools';

export default {
  defaultProps: {
    colorScheme: 'brand.300',
  },
};
